module.exports = __webpack_public_path__ + "static/media/mw.479bfd88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mw.svg
// module id = 201
// module chunks = 0